import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthSignedIn, AuthSignedOut } from '@mystudioclass/auth';
import { SocketProvider } from './contexts/SocketContext';

// Auth Pages (Better Auth)
import SignInPage from './pages/auth/SignInPage';
import SignUpPage from './pages/auth/SignUpPage';
import ForgotPasswordPage from './pages/auth/ForgotPasswordPage';
import ProfileGate from './components/ProfileGate';

// Business Pages
import DashboardPage from './pages/DashboardPage';
import VideosPage from './pages/VideosPage';
import SchedulePage from './pages/SchedulePage';
import MarketingPage from './pages/MarketingPage';
import CRMPage from './pages/CRMPage';
import CommunityPage from './pages/CommunityPage';
import SubscriptionPage from './pages/SubscriptionPage';
import SettingsPage from './pages/SettingsPage';
// FEATURE_DISABLED: Help & Support page - re-enable when ready
// import HelpSupportPage from './pages/HelpSupportPage';

// Customer Pages
import CustomerDashboardPage from './pages/CustomerDashboardPage';
import CustomerSchedulePage from './pages/CustomerSchedulePage';
import CustomerClassesPage from './pages/CustomerClassesPage';
import CustomerCommunityPage from './pages/CustomerCommunityPage';
import CustomerSubscriptionPage from './pages/CustomerSubscriptionPage';
import StudentSchedulePage from './pages/StudentSchedulePage';

// Layout
import Layout from './components/Layout';
import CustomerLayout from './components/CustomerLayout';

function AppRoutes() {
  return (
    <Routes>
      {/* Auth Routes - redirect to dashboard if already signed in */}
      <Route path="/sign-in/*" element={
        <>
          <AuthSignedIn><Navigate to="/dashboard" replace /></AuthSignedIn>
          <AuthSignedOut><SignInPage /></AuthSignedOut>
        </>
      } />
      {/* Sign-up page handles its own navigation after API call completes */}
      <Route path="/sign-up/*" element={<SignUpPage />} />

      {/* Forgot password - accessible when signed out */}
      <Route path="/forgot-password" element={
        <>
          <AuthSignedIn><Navigate to="/dashboard" replace /></AuthSignedIn>
          <AuthSignedOut><ForgotPasswordPage /></AuthSignedOut>
        </>
      } />

      {/* Legacy routes - redirect to new Better Auth routes */}
      <Route path="/login" element={<Navigate to="/sign-in" replace />} />
      <Route path="/register" element={<Navigate to="/sign-up" replace />} />
      <Route path="/register/customer" element={<Navigate to="/sign-up" replace />} />

      {/* Customer routes with CustomerLayout */}
      <Route path="/customer" element={
        <ProfileGate>
          <CustomerLayout />
        </ProfileGate>
      }>
        <Route index element={<Navigate to="/customer/dashboard" replace />} />
        <Route path="dashboard" element={<CustomerDashboardPage />} />
        <Route path="schedule" element={<CustomerSchedulePage />} />
        <Route path="classes" element={<CustomerClassesPage />} />
        <Route path="community" element={<CustomerCommunityPage />} />
        <Route path="subscription" element={<CustomerSubscriptionPage />} />
      </Route>

      {/* Legacy student route */}
      <Route path="/student/schedule" element={
        <ProfileGate>
          <StudentSchedulePage />
        </ProfileGate>
      } />

      {/* Business routes */}
      <Route path="/" element={
        <ProfileGate>
          <SocketProvider>
            <Layout />
          </SocketProvider>
        </ProfileGate>
      }>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="videos" element={<VideosPage />} />
        <Route path="schedule" element={<SchedulePage />} />
        <Route path="marketing" element={<MarketingPage />} />
        <Route path="crm" element={<CRMPage />} />
        <Route path="community" element={<CommunityPage />} />
        <Route path="subscription" element={<SubscriptionPage />} />
        <Route path="settings" element={<SettingsPage />} />
        {/* FEATURE_DISABLED: Help & Support page - re-enable when ready */}
        {/* <Route path="help" element={<HelpSupportPage />} /> */}
      </Route>

      {/* 404 - Redirect to sign-in for unknown routes */}
      <Route path="*" element={<Navigate to="/sign-in" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
